export default {
    name: 'DonationCard',
    props: {
        result: {
            type: Object,
            required: true
        },
        modifierClass:{
            type: String,
            required: false
        }
    },
    setup() {

        const formatAmount = (value) => {
            if (value === null || value === undefined) return ''

            const number = Number(value)

            const formatter = new Intl.NumberFormat('da-DK', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            })

            return formatter.format(number)
        }

        return {
            formatAmount
        }
    }
}
